import { render } from "./MenuTableCellInputCheckbox.vue?vue&type=template&id=0bf75620"
import script from "./MenuTableCellInputCheckbox.vue?vue&type=script&lang=js"
export * from "./MenuTableCellInputCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__